@if (createShipments$ | async) {
  <div class="fab">
    <button mat-fab color="accent" [disabled]="busy$ | async" (click)="createShipment()">
      <app-icon icon="quote" [beatFade]="busy$ | async"></app-icon>
    </button>
  </div>
}
